// функция alert
export default function handleConfirm(message, onAction) {
    const isConfirmed = window.confirm(message);
    if (onAction) onAction(isConfirmed);
    return isConfirmed
};